import React from "react";
import moment from "moment";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import PopUpComponent from "../../components/PopUp/PopUpComponent";
import PdfSuratJalan from "../../components/PdfSuratJalan/PdfSuratJalan";
import CloseLogo from "../../Assets/close_icon.png";
import RefreshIcon from "../../Assets/refresh-icon.png";
import SearchLogo from "../../Assets/search-icon.png";
import { fmt } from "./poHelpers";

/* =========================================================
   TAB SURAT JALAN
   ========================================================= */
export function PoSuratJalanTab({ po }) {
  const {
    checkingRole,
    filterDateMemoKirim,
    setFilterDateMemoKirim,
    valueSearchMemo,
    setValueSearchMemo,
    dataTempMemoSearch,
    dataMirrorSj,
    setIsRefreshMantap,
    setIsRefreshMemoKirim,
    handleOpenCancel,
  } = po;

  // kelompokkan per nomor surat jalan
  const groups = {};
  (dataTempMemoSearch || [])
    .filter((e) => e.noSj)
    .forEach((e) => {
      if (!groups[e.noSj]) {
        groups[e.noSj] = { noSj: e.noSj, customer: e.customer, items: [] };
      }
      groups[e.noSj].items.push(e);
    });
  const list = Object.values(groups).sort((a, b) =>
    a.noSj.localeCompare(b.noSj)
  );

  const downloadSj = async (g) => {
    const dataSj = (dataMirrorSj || [])
      .filter((i) => i.jumlah > 0)
      .sort((a, b) => {
        const na = a.noLine !== null && !isNaN(a.noLine);
        const nb = b.noLine !== null && !isNaN(b.noLine);
        if (na && nb) return Number(a.noLine) - Number(b.noLine);
        return na ? -1 : nb ? 1 : 0;
      });
    const blob = await pdf(
      <PdfSuratJalan
        data={dataSj}
        date={filterDateMemoKirim}
        noSj={g.noSj}
        customer={g.customer}
      />
    ).toBlob();
    // "/" tidak boleh ada di nama file
    saveAs(
      blob,
      `${g.noSj.replace(/\//g, "-")} ${g.customer} ${moment(filterDateMemoKirim)
        .utcOffset("+0700")
        .format("DD-MM-YY")}.pdf`
    );
  };

  return (
    <>
      <div className="po-toolbar">
        <div className="po-toolbar-group">
          <input
            className="po-input po-input--date"
            type="date"
            value={filterDateMemoKirim}
            onChange={(e) => setFilterDateMemoKirim(e.target.value)}
          />
          <div className="po-search">
            <input
              className="po-search-input"
              type="text"
              placeholder="Cari No. SJ / PO / barang"
              value={valueSearchMemo}
              onChange={(e) => setValueSearchMemo(e.target.value)}
            />
            <p className="po-search-icon">
              <img src={SearchLogo} alt="cari" />
            </p>
          </div>
          <img
            className="po-refresh"
            src={RefreshIcon}
            alt="refresh"
            onClick={() => {
              setIsRefreshMantap(true);
              setIsRefreshMemoKirim(true);
            }}
          />
        </div>
      </div>

      {list.length === 0 ? (
        <div className="po-empty">
          Belum ada surat jalan pada tanggal ini. Buat dari tab Memo Kirim
          dengan mencentang item.
        </div>
      ) : (
        <div className="po-sj-list">
          {list.map((g) => {
            const total = g.items.reduce((s, a) => s + a.jumlah, 0);
            const pols = [
              ...new Set(g.items.map((i) => i.noPol).filter(Boolean)),
            ];
            const allCancelled = total === 0;
            return (
              <div className="po-sj-card" key={g.noSj}>
                <div className="po-sj-head">
                  <div className="po-sj-meta">
                    <button className="po-link" onClick={() => downloadSj(g)}>
                      {g.noSj}
                    </button>
                    <span className="po-badge">{g.customer}</span>
                    <span>
                      {moment(filterDateMemoKirim).format("DD-MM-YYYY")}
                    </span>
                    <span>
                      Total <b>{fmt(total)}</b> pcs
                    </span>
                    {pols.length ? (
                      <span>No. Pol: {pols.join(", ")}</span>
                    ) : null}
                    {allCancelled ? (
                      <span className="po-badge po-badge--external">
                        Dibatalkan
                      </span>
                    ) : null}
                  </div>
                  {checkingRole && !allCancelled ? (
                    <button
                      className="po-btn po-btn--ghost po-btn--sm"
                      onClick={() => handleOpenCancel(g.noSj)}
                    >
                      Cancel SJ
                    </button>
                  ) : null}
                </div>
                <table className="po-table">
                  <thead>
                    <tr>
                      <th className="po-th">No.</th>
                      <th className="po-th">Nama Barang</th>
                      <th className="po-th">No. PO</th>
                      <th className="po-th">Line</th>
                      <th className="po-th">Jumlah</th>
                      <th className="po-th">No. Pol</th>
                    </tr>
                  </thead>
                  <tbody>
                    {g.items.map((it, i) => (
                      <tr
                        key={it._id}
                        className={`po-row ${
                          it.jumlah === 0 ? "po-row--cancelled" : ""
                        }`}
                      >
                        <td className="po-td">{i + 1}.</td>
                        <td className="po-td">
                          {it.customer === "YBI" ? it.kodeBarang : ""}{" "}
                          {it.itemPo}
                        </td>
                        <td className="po-td">{it.noPo}</td>
                        <td className="po-td">
                          {it.noLine || ""}
                          {it.kodeLine ? ` - ${it.kodeLine}` : ""}
                        </td>
                        <td className="po-td po-nowrap">{fmt(it.jumlah)}</td>
                        <td className="po-td">{it.noPol}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

/* =========================================================
   POPUP TIKET CANCELLATION
   ========================================================= */
export function PoCancelPopup({ po }) {
  const {
    sjOptions,
    cancelNoSj,
    cancelType,
    setCancelType,
    cancelReason,
    setCancelReason,
    cancelItems,
    errCancel,
    handlePickNoSjCancel,
    handleToggleCancelItem,
    handleChangeCancelQty,
    handleStepCancelQty,
    handleSubmitCancel,
    handleCloseCancel,
    disabledButton,
  } = po;

  const isInternal = cancelType === "internal";

  // jumlah item yang dicentang (bermasalah / dicancel)
  const totalCancel = cancelItems
    .filter((i) => i.checked)
    .reduce((s, a) => s + Number(a.jumlahCancel || 0), 0);
  // internal: seluruh isi SJ kembali ke Memo Kirim
  const totalKembali = cancelItems.reduce(
    (s, a) => s + Number(a.jumlahAsli || 0),
    0
  );

  return (
    <PopUpComponent className="po-modal po-modal--lg">
      <div className="po-modal-head">
        <h3 className="po-modal-title">Tiket Cancellation</h3>
        <img
          style={{ width: 36, height: 36, cursor: "pointer" }}
          src={CloseLogo}
          alt="tutup"
          onClick={handleCloseCancel}
        />
      </div>

      <div className="po-form-row">
        <div className="po-field">
          <label className="po-label">No. Surat Jalan</label>
          <select
            className="po-select"
            style={{ width: 200 }}
            value={cancelNoSj}
            onChange={(e) => handlePickNoSjCancel(e.target.value)}
          >
            <option value="" disabled>
              Pilih No. SJ
            </option>
            {sjOptions.map((no) => (
              <option key={no} value={no}>
                {no}
              </option>
            ))}
          </select>
        </div>
        <div className="po-field">
          <label className="po-label">Jenis Cancel</label>
          <div className="po-seg">
            <button
              type="button"
              className={cancelType === "internal" ? "is-active" : ""}
              onClick={() => setCancelType("internal")}
            >
              Internal
            </button>
            <button
              type="button"
              className={cancelType === "external" ? "is-active" : ""}
              onClick={() => setCancelType("external")}
            >
              External
            </button>
          </div>
        </div>
      </div>

      {isInternal ? (
        <p className="po-hint">
          Internal: centang item yang <b>bermasalah</b> (tercatat di riwayat
          tiket). Sistem tetap mengembalikan <b>semua item</b> di No. SJ ini ke
          Memo Kirim dan mengosongkan No. SJ-nya. Jumlah di tabel PO tidak
          berubah.
        </p>
      ) : (
        <p className="po-hint po-hint--warn">
          External: centang item yang dibatalkan, lalu atur jumlahnya. Jumlah
          dikurangi dari Surat Jalan dan dari jadwal kirim di tabel PO pada
          tanggal itu, sehingga Sisa kiriman bertambah (Total PO tidak berubah).
          Jika semua jumlah pada tanggal itu dibatalkan, jadwalnya dihapus.
        </p>
      )}

      <div className="po-table-wrap" style={{ maxHeight: "40vh" }}>
        <table className="po-table">
          <thead>
            <tr>
              <th className="po-th" style={{ width: 36 }} />
              <th className="po-th">Nama Barang</th>
              <th className="po-th">No. PO</th>
              <th className="po-th">Jml SJ</th>
              <th className="po-th">
                {isInternal ? "Jml Bermasalah" : "Jml Cancel"}
              </th>
            </tr>
          </thead>
          <tbody>
            {cancelItems.length === 0 ? (
              <tr>
                <td className="po-empty" colSpan={5}>
                  Pilih No. Surat Jalan untuk menampilkan itemnya.
                </td>
              </tr>
            ) : null}
            {cancelItems.map((it, i) => (
              <tr
                key={it._id}
                className={`po-row ${i % 2 ? "po-row--alt" : ""}`}
              >
                <td className="po-td">
                  <input
                    className="po-checkbox"
                    type="checkbox"
                    checked={it.checked}
                    onChange={() => handleToggleCancelItem(it._id)}
                  />
                </td>
                <td className="po-td">
                  {it.customer === "YBI" ? it.kodeBarang : ""} {it.itemPo}
                </td>
                <td className="po-td">{it.noPo}</td>
                <td className="po-td po-nowrap">{fmt(it.jumlahAsli)}</td>
                <td className="po-td">
                  <div className="po-stepper">
                    <button
                      type="button"
                      className="po-btn-square"
                      disabled={!it.checked}
                      onClick={() => handleStepCancelQty(it._id, -1)}
                    >
                      &#8722;
                    </button>
                    <input
                      className="po-input"
                      type="number"
                      disabled={!it.checked}
                      value={it.jumlahCancel}
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) =>
                        handleChangeCancelQty(it._id, e.target.value)
                      }
                    />
                    <button
                      type="button"
                      className="po-btn-square"
                      disabled={!it.checked}
                      onClick={() => handleStepCancelQty(it._id, 1)}
                    >
                      &#43;
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <label className="po-label" style={{ marginTop: 12 }}>
        Keterangan / alasan cancel
      </label>
      <textarea
        className="po-textarea"
        placeholder="Contoh: barang reject di customer, salah kirim item, dll."
        value={cancelReason}
        onChange={(e) => setCancelReason(e.target.value)}
      />
      {errCancel ? <p className="po-error">{errCancel}</p> : null}

      <div className="po-actions-end" style={{ alignItems: "center" }}>
        <span className="po-summary">
          {isInternal ? "Jml bermasalah" : "Total cancel"}{" "}
          <b>{fmt(totalCancel)}</b> pcs
          {isInternal && cancelItems.length > 0 ? (
            <>
              {" "}
              · seluruh <b>{cancelItems.length}</b> item (
              <b>{fmt(totalKembali)}</b> pcs) kembali ke Memo Kirim
            </>
          ) : null}
        </span>
        <button className="po-btn po-btn--ghost" onClick={handleCloseCancel}>
          Batal
        </button>
        <button
          className="po-btn po-btn--danger"
          disabled={disabledButton}
          onClick={handleSubmitCancel}
        >
          Kirim Tiket
        </button>
      </div>
    </PopUpComponent>
  );
}

/* =========================================================
   TAB RIWAYAT TIKET CANCELLATION
   ========================================================= */
export function PoRiwayatTab({ po }) {
  const {
    dataHistoryCancel,
    filterBulanHistory,
    setFilterBulanHistory,
    setIsRefreshHistory,
  } = po;
  const rows = dataHistoryCancel || [];

  return (
    <>
      <div className="po-toolbar">
        <div className="po-toolbar-group">
          <input
            className="po-input po-input--date"
            type="month"
            value={filterBulanHistory}
            onChange={(e) => setFilterBulanHistory(e.target.value)}
          />
          <img
            className="po-refresh"
            src={RefreshIcon}
            alt="refresh"
            onClick={() => setIsRefreshHistory(true)}
          />
        </div>
        <span className="po-summary">
          <b>{rows.length}</b> tiket
        </span>
      </div>

      <div className="po-table-wrap" style={{ maxHeight: "72vh" }}>
        <table className="po-table">
          <thead>
            <tr>
              <th className="po-th">No.</th>
              <th className="po-th">Waktu Tiket</th>
              <th className="po-th">No. SJ</th>
              <th className="po-th">Cust</th>
              <th className="po-th">Jenis</th>
              <th className="po-th">Item bermasalah / dicancel</th>
              <th className="po-th">Total</th>
              <th className="po-th">Keterangan</th>
              <th className="po-th">Dibuat oleh</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td className="po-empty" colSpan={9}>
                  Belum ada tiket cancellation pada bulan ini.
                </td>
              </tr>
            ) : null}
            {rows.map((r, i) => (
              <tr
                key={r.ticketId}
                className={`po-row ${i % 2 ? "po-row--alt" : ""}`}
              >
                <td className="po-td">{i + 1}.</td>
                <td className="po-td po-nowrap">
                  {moment(r.createdAt)
                    .utcOffset("+0700")
                    .format("DD-MM-YYYY HH:mm")}
                </td>
                <td className="po-td po-nowrap">{r.noSj}</td>
                <td className="po-td">{r.customer}</td>
                <td className="po-td">
                  <span className={`po-badge po-badge--${r.type}`}>
                    {r.type === "internal" ? "Internal" : "External"}
                  </span>
                </td>
                <td
                  className="po-td"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {(r.items || []).map((it, k) => (
                    <div key={k}>
                      {it.itemPo}{" "}
                      <span className="po-summary">({it.noPo})</span> —{" "}
                      <b>{fmt(it.jumlahCancel)}</b> / {fmt(it.jumlahSebelum)}{" "}
                      pcs
                    </div>
                  ))}
                </td>
                <td className="po-td po-nowrap">{fmt(r.totalCancel)}</td>
                <td className="po-td" style={{ maxWidth: 260 }}>
                  {r.reason}
                </td>
                <td className="po-td">{r.createdBy}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
